export const skillsData = [
  'n8n',
  'Python',
  'FastAPI',
  'React',
  'TypeScript',
  'LangChain',
  'Docker',
  'PostgreSQL',
  'Google Workspace',
  'Notion',
  'ChatGPT',
  'Claude Code',
  'API Integration',
  'Automation',
  'Spring Boot',
  'MySQL',
  'Google Calendar API',
  'Gmail API',
  'Google Drive'
]
